window.OneLuxuryImmersiveOrbitConfig = Object.freeze({
  version: '2026-07-17.5',
  expectedSlots: 40,
  expectedUniqueAssets: 19,
  expectedLinkedDuplicates: 21,
  groups: Object.freeze({ core: 12, field: 28 }),
  depthTiers: Object.freeze({ foreground: 9, midground: 17, background: 14 }),
  materials: Object.freeze({ yellow: 28, rose: 8, white: 4 }),
  orb: Object.freeze({ radius: 1.11, clearance: 0.42, desktopX: 1.25, desktopY: 0.35, mobileX: 0, mobileY: 1.05 }),
  camera: Object.freeze({
    desktop: Object.freeze({ fov: 34, x: 0, y: 1.05, z: 12.6, lookX: 0, lookY: 0.3 }),
    tablet: Object.freeze({ fov: 35, x: 0, y: 1.1, z: 14.4, lookX: 0, lookY: 0.45 }),
    mobile: Object.freeze({ fov: 32, x: 0, y: 1.3, z: 17.2, lookX: 0, lookY: -0.75 })
  }),
  qualityProfiles: Object.freeze({
    high: Object.freeze({ maxDpr: 1.75, antialias: true, shadows: true, shadowMapSize: 1536, sphereSegments: 64, orbitSegments: 144, exposure: 0.94 }),
    balanced: Object.freeze({ maxDpr: 1.5, antialias: true, shadows: true, shadowMapSize: 1024, sphereSegments: 48, orbitSegments: 112, exposure: 0.92 }),
    mobile: Object.freeze({ maxDpr: 1.25, antialias: true, shadows: false, shadowMapSize: 512, sphereSegments: 36, orbitSegments: 88, exposure: 0.9 })
  }),
  motion: Object.freeze({ pointerStrength: 0.16, cameraDamping: 0.035, breathingAmplitude: 0.045, maxDelta: 0.05 }),
  collision: Object.freeze({ modelRadiusFactor: 0.42, modelMargin: 0.14, sphereMargin: 0.18, validationSamples: 720 }),
  fallbackTimeoutMs: 30000
});
